var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegisteredTrademarkWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 88.5,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    fill: "#fff",
    d: "M94.6 92C100.1 92 104.1 90.9 106.5 88.8C108.9 86.8 110.2 83.4 110.2 78.6C110.2 73.9 108.9 70.6 106.5 68.5C104.1 66.5 100.1 65.5 94.6 65.5L83.4 65.5L83.4 92L94.6 92M83.4 110.3L83.4 149.3L56.8 149.3L56.8 46.2L97.4 46.2C111 46.2 120.9 48.5 127.2 53.1C133.6 57.6 136.7 64.8 136.7 74.7C136.7 81.5 135.1 87.1 131.8 91.5C128.5 95.8 123.6 99.1 116.9 101.1C120.6 102 123.8 103.9 126.7 106.8C129.6 109.7 132.5 114.1 135.4 120.1L149.9 149.3L121.6 149.3L109 123.7C106.5 118.6 103.9 115 101.3 113.2C98.7 111.3 95.2 110.3 90.9 110.3L83.4 110.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisteredTrademarkWhite);
export default __webpack_public_path__ + "static/media/registered-trademark-white.4b0b924096521aa016cc69e36dbc5e2d.svg";
export { ForwardRef as ReactComponent };